//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {mapGetters} from "vuex";

export default {
  name: "SectionEventPlaceEventsSlider",
  components: {
    EmptyEntityCardsSlider: () => import("@/components/common/EmptyEntityCardsSlider"),
    Section: () => import("@/components/common/Section/index"),
    EventCard: () => import("@/components/common/EventCard/index"),
    SliderWithBullets: () => import("@/components/common/SliderWithBullets/index"),
    Scroller: () => import("@/components/common/Scroller")
  },
  data() {
    return {
      eventsFromPlace: [],
      show: false,
      pending: true
    };
  },
  computed: {
    ...mapGetters({
      place: "event/place",
      eventId: "event/id"
    }),
    gap() {
      return this.$mediaSwitch({hd: 32, sm: 8, defaultValue: 24});
    },
    columns() {
      return this.$mediaSwitch({md: 2, sm: 1, defaultValue: 3});
    }
  },
  async mounted() {
    if (this.place) {
      this.show = true
      await this.$axios.$get(`api/events?place_id=${this?.place?.id}&started_at=${this.$moment().format("YYYY-MM-DD")}`)
        .then((resolve) => {
          const result = resolve?.data?.filter(item => item.id !== this.eventId)
          this.eventsFromPlace = result
          result.length > 0 ? this.show = true : this.show = false
        })
        .finally(() => {
          this.pending = false
        })
    }
  }
};
